/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface BulkRemoveFolderDocumentsResponse
 */
export interface BulkRemoveFolderDocumentsResponse {
  /**
   *
   * @type {number}
   * @memberof BulkRemoveFolderDocumentsResponse
   */
  status?: number
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof BulkRemoveFolderDocumentsResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function BulkRemoveFolderDocumentsResponseFromJSON(json: any): BulkRemoveFolderDocumentsResponse {
  return BulkRemoveFolderDocumentsResponseFromJSONTyped(json, false)
}

export function BulkRemoveFolderDocumentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkRemoveFolderDocumentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function BulkRemoveFolderDocumentsResponseToJSON(value?: BulkRemoveFolderDocumentsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
